// import { defaultNetworkService } from '../../../../../services/network'
import axios from "axios";
import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../../../utils/queryParams.js";

export const SET_LOADING = "saga/SET_LOADING";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "saga/FETCH_CURRENT_USER_FAILURE";

export const FETCH_MEMBERSHIP_BREAKDOWN_SUCCESS = "saga/FETCH_MEMBERSHIP_BREAKDOWN_SUCCESS";
export const FETCH_MEMBERSHIP_BREAKDOWN_FAILURE = "saga/FETCH_MEMBERSHIP_BREAKDOWN_FAILURE";
export const UPDATE_DATE = "saga/UPDATE_DATE";
export const UPDATE_GROUP_BY_REVENUE_CATEGORY = "saga/UPDATE_GROUP_BY_REVENUE_CATEGORY";
export const UPDATE_INCLUDE_ZERO_SALES = "saga/UPDATE_INCLUDE_ZERO_SALES";
export const UPDATE_CHART_SUCCESS = "saga/UPDATE_CHART_SUCCESS";
export const UPDATE_CHART_FAILURE = "saga/UPDATE_CHART_FAILURE";
export const SET_TABLE_LOADING = "saga/SET_TABLE_LOADING";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateDate: createAction(UPDATE_DATE),
  updateGroupByRevenueCategory: createAction(UPDATE_GROUP_BY_REVENUE_CATEGORY),
  updateIncludeZeroSales: createAction(UPDATE_INCLUDE_ZERO_SALES)
};

export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_DATE, getMembershipBreakdown);
  yield takeLatest(UPDATE_GROUP_BY_REVENUE_CATEGORY, getMembershipBreakdown);
  yield takeLatest(UPDATE_INCLUDE_ZERO_SALES, getMembershipBreakdown);
}

export function* getCurrentUserData(data) {
  try {
    // Get user data first. Once we confirm we have user data pass to other sagas and call them.
    yield put({ type: SET_LOADING, payload: true });
    yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload });

    yield getMembershipBreakdown();
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_CURRENT_USER_FAILURE, error });
  }
}

export function* getMembershipBreakdown() {
  yield put({ type: SET_TABLE_LOADING, payload: true });

  const [id, objectId, locationId, regionId, date, groupByRevenueCategory, includeZeroSales] = yield select(state => [
    state.membershipBreakdown.currentUser.params.organization_id,
    state.membershipBreakdown.currentUser.params.current_object_id,
    state.membershipBreakdown.currentUser.params.current_location_id,
    state.membershipBreakdown.currentUser.params.current_region_id,
    state.membershipBreakdown.date,
    state.membershipBreakdown.groupByRevenueCategory,
    state.membershipBreakdown.includeZeroSales
  ]);

  try {
    const membershipBreakdownResponse = yield call(
      axios.get,
      queryParams.apiVersion +
        "pages/memberships/membership_breakdown" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&object_id=" +
        objectId +
        "&region_id=" +
        regionId +
        "&date=" +
        date +
        "&group_by_revenue_category=" +
        groupByRevenueCategory +
        "&include_zero_sales=" +
        includeZeroSales
    );
    yield put({ type: FETCH_MEMBERSHIP_BREAKDOWN_SUCCESS, payload: membershipBreakdownResponse.data });
  } catch (error) {
    console.error(error)
  }
}
